export default {
  FAILURE: 'failure',
  SUCCESS: 'success',
  GENERAL: 'general',
  AUTO_APP: 'auto-app',
};
